import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaintenanceNoticeComponent } from './containers/maintenance-notice/maintenance-notice.component';
import { oAuthRoutes } from '../oauth/oauth.routes';
import { SamlErrorPageComponent } from './containers/saml-error-page/saml-error-page.component';
import { UasPortalComponent } from './containers/uas-portal.component';
import { DisableNoticeComponent } from './containers/disable-notice/disable-notice.component';

export const UAS_ROUTES: Routes = [
  {
    path: 'uas/portal',
    component: UasPortalComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth',
      },
      ...oAuthRoutes,
      {
        path: 'saml-error',
        component: SamlErrorPageComponent
      },
      {
        path: 'maintenance-notice',
        component: MaintenanceNoticeComponent
      },
      {
        path: 'disable-notice',
        component: DisableNoticeComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(UAS_ROUTES)],
  exports: [RouterModule]
})
export class UasPortalRoutingModule {
}
